export class StateHistory {
    public stateId:string;
    public subStateId:string;
    constructor(stateId:string, subStateId:string){
        this.stateId = stateId;
        this.subStateId = subStateId;
    }
    public toString(){
        return `${this.stateId}:${this.subStateId}`;
    }
}